<template>
  <div class="sp-template plate-template order-plate-template">
    <div class="h-title">{{title}}</div>
    <el-card class="box-card">
      <el-form :model="form" size="small" :rules="rulesform" ref="formref" class="new-order__form" :label-width="formLabelWidth">
        <div class="plate-content">
          <div class="plate-content__title">
            <span class="title">基本信息</span>
          </div>
          <div class="view-customer" v-if="isLook">
            <el-form-item label="登录账号">{{form.username}}</el-form-item>
            <el-form-item label="联系人">{{form.name}}</el-form-item>
            <el-form-item label="公司名称">{{form.orgName}}</el-form-item>
            <el-form-item label="公司代码">{{form.companyCode}}</el-form-item>
            <el-form-item label="联系方式">{{form.companyTel}}</el-form-item>
            <el-form-item label="联系邮箱">{{form.companyEmail}}</el-form-item>
            <el-form-item label="公司地址">{{form.companyAddress}}</el-form-item>
            <el-form-item label="上门取件地址">{{form.province}} {{form.city}} {{form.address}}</el-form-item>
          </div>
          <div v-else>
            <div class="inline-flex">
              <div>
                <el-form-item label="登录账号"  prop="username">
                  <el-input v-model.lazy="form.username" placeholder="登录账号"></el-input>
                </el-form-item>
                <el-form-item label="联系人"  prop="name">
                  <el-input v-model.lazy="form.name" placeholder="联系人"></el-input>
                </el-form-item>
                <el-form-item label="公司名称"  prop="orgName">
                  <el-input v-model.lazy="form.orgName" placeholder="公司名称"></el-input>
                </el-form-item>
                <el-form-item label="公司地址"  prop="companyAddress">
                  <span v-if="isLook">{{form.companyAddress}}</span>
                  <el-input v-else v-model.lazy="form.companyAddress" placeholder="公司地址"></el-input>
                </el-form-item>
              </div>
              <div>
                <el-form-item v-show="!isLook" label="登录密码"  prop="pwd">
                  <el-input v-model.lazy="form.pwd" type="password" placeholder="登录密码"></el-input>
                </el-form-item>
                <el-form-item label="联系方式"  prop="companyTel">
                  <el-input v-model.lazy="form.companyTel" placeholder="联系方式"></el-input>
                </el-form-item>
                <el-form-item label="联系邮箱"  prop="companyEmail">
                  <el-input v-model.lazy="form.companyEmail" placeholder="联系邮箱"></el-input>
                </el-form-item>
                <!-- <el-form-item v-show="false" label="创建日期" >
                  <span v-if="isLook">{{form.createAt}}</span>
                  <el-date-picker v-else v-model.lazy="form.createAt" type="date" :picker-options="createAtOptions" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item> -->
              </div>
            </div>
            <div>
              <el-form-item label="上门取件地址" >
                <el-select v-model="form.province" @change="queryCityOfChina" filterable placeholder="州/省" style="width: 150px;">
                  <el-option v-for="(province,i) in initialDataProvinceChina" :key="i" :label="province.nameCn" :value="province.nameCn"></el-option>
                </el-select>
                <el-select v-model="form.city" filterable placeholder="市" style="width: 150px;">
                  <el-option v-for="(city,i) in initialDataCityChina" :key="i" :label="city.nameCn" :value="city.nameCn"></el-option>
                </el-select>
                <el-input v-model.lazy="form.address" style="width:430px" placeholder="详细地址"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="plate-content">
          <div class="plate-content__title">
            <span class="title">证件信息</span>
          </div>
          <div class="view-customer padding-left" v-if="isLook">
            <div class="img-box">
              <div class="box">
                <div class="label">营业执照</div>
                <div class="img"><img class="img" :src="businessLicenseImgUrl"></div>
              </div>
              <div class="box">
                <div class="label">一般纳税人</div>
                <div class="img"><img class="img" :src="openingAccountsImgUrl"></div>
              </div>
            </div>
            <div class="img-box">
              <div class="box">
                <div class="label">身份证正面</div>
                <div class="img"><img class="img" :src="contactIDFrontImgUrl"></div>
              </div>
              <div class="box">
                <div class="label">身份证反面</div>
                <div class="img"><img class="img" :src="contactIDBackImgUrl"></div>
              </div>
            </div>
            <div class="img-box">
              <div class="box">
                <div class="label">开户许可证</div>
                <div class="img"><img class="img" :src="taxpayerImgUrl"></div>
              </div>
            </div>
          </div>
          <div v-else class="inline-flex">
            <div>
              <el-form-item label="营业执照" >
                <el-upload action="#" :file-list="imgListBusinessLicenseImg" accept="image/png,image/gif,image/jpg,image/jpeg" list-type="picture-card" :limit="1" :on-change="imgChangeBusinessLicenseImg" :on-remove="rmBusinessLicenseImg" :auto-upload="false">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="身份证正面" >
                <el-upload action="#" list-type="picture-card" :file-list="imgListContactIDFrontImg" accept="image/png,image/gif,image/jpg,image/jpeg" :limit="1" :on-change="imgChangeContactIDFrontImg" :on-remove="rmContactIDFrontImg" :auto-upload="false">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="一般纳税人" >
                <el-upload action="#" list-type="picture-card" :file-list="imgListOpeningAccountsImg" accept="image/png,image/gif,image/jpg,image/jpeg" :limit="1" :on-change="imgChangeOpeningAccountsImg" :on-remove="rmOpeningAccountsImg" :auto-upload="false">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="开户许可证" >
                <el-upload action="#" list-type="picture-card" :file-list="imgListTaxpayerImg" accept="image/png,image/gif,image/jpg,image/jpeg" :limit="1" :on-change="imgChangeTaxpayerImg" :on-remove="rmTaxpayerImg" :auto-upload="false">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="身份证反面" >
                <el-upload action="#" list-type="picture-card" :file-list="imgListContactIDBackImg" accept="image/png,image/gif,image/jpg,image/jpeg" :limit="1" :on-change="imgChangeContactIDBackImg" :on-remove="rmContactIDBackImg" :auto-upload="false">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="plate-content">
          <div class="plate-content__title">
            <span class="title">其它信息</span>
          </div>
          <div class="view-customer" v-if="isLook">
            <el-form-item label="账号状态">{{userStatusListMap[form.userStatus]}}</el-form-item>
            <el-form-item label="业务员">{{form.salesmanName}}</el-form-item>
            <el-form-item label="结算方式">{{form.paymentTermsName}}</el-form-item>
            <el-form-item label="客户类型">{{form.customerTypeName}}</el-form-item>
            <el-form-item label="分配产品"><span class="block">{{form.channelName}}</span></el-form-item>
            <el-form-item label="单独报价产品"><span class="block">{{form.channelQuote}}</span></el-form-item>
            <el-form-item label="先付款产品"><span class="block">{{form.cashBeforeDeliveryChannelName}}</span></el-form-item>
            <el-form-item label="订单审核">{{form.orderReview == 'true' ? "是" : "否"}}</el-form-item>
            <el-form-item label="地址校验">{{form.addressConfirm == 'true' ? "是" : "否"}}</el-form-item>
            <el-form-item label="确认发货">
              {{form.deliveryConfirmation == 'true' ? "是" : "否"}}
              <el-tooltip effect="dark" content="是否需要由客户确认后才发货" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="客服">{{form.customerServiceStaffName}}</el-form-item>
            <el-form-item label="信用额度(元)">{{form.credits}}</el-form-item>
            <el-form-item label="分配仓库"><span class="block">{{form.warehouseName}}</span></el-form-item>
          </div>
          <div class="inline-flex" v-else>
            <div>
              <el-form-item label="账号状态"  prop="userStatus">
                <el-select v-model.lazy="form.userStatus">
                  <el-option v-for="(d, i) in userStatusList" :key="i" :label="d.name" :value="d.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户类型"  prop="customerType">
                <el-select v-model.lazy="form.customerType">
                  <el-option v-for="(d, i) in customerTypeList" :key="i" :label="d.name" :value="d.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结算方式"  prop="paymentTerms">
                <el-select v-model.lazy="form.paymentTerms">
                  <el-option v-for="(d, i) in paymentTermsList" :key="i" :label="d.name" :value="d.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务员"  prop="salesman">
                <el-select v-model.lazy="form.salesman">
                  <el-option v-for="(d, i) in salesmans" :key="i" :label="d.name" :value="d.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分配产品"  prop="channel">
                <el-select v-model.lazy="form.channel" multiple filterable clearable @change="getCashBeforeDeliveryChannel()">
                  <el-option v-for="(d, i) in channelData" :key="i" :label="d.nameCN" :value="d.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="单独报价产品" >
                <el-select v-model.lazy="form.channelQuote" multiple filterable clearable>
                  <el-option v-for="(d, i) in cashBeforeDeliveryChannelData" :key="i" :label="d.nameCN" :value="d.id"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="先付款产品" >
                <el-select v-model.lazy="form.cashBeforeDeliveryChannel" multiple filterable clearable>
                  <el-option v-for="(d, i) in cashBeforeDeliveryChannelData" :key="i" :label="d.nameCN" :value="d.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否可以查看批次轨迹信息"  prop="orderReview">
                <el-select v-model.lazy="form.viewBatchTracking">
                  <el-option label="是" value="true"></el-option>
                  <el-option label="否" value="false"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="订单审核"  prop="orderReview">
                <el-select v-model.lazy="form.orderReview">
                  <el-option label="是" value="true"></el-option>
                  <el-option label="否" value="false"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="地址校验"  prop="addressConfirm">
                <el-select v-model.lazy="form.addressConfirm">
                  <el-option label="是" value="true"></el-option>
                  <el-option label="否" value="false"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="确认发货"  prop="deliveryConfirmation">
                <el-select v-model.lazy="form.deliveryConfirmation">
                  <el-option label="是" value="true"></el-option>
                  <el-option label="否" value="false"></el-option>
                </el-select>
                <el-tooltip effect="dark" content="是否需要由客户确认后才发货" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </el-form-item>
              <el-form-item label="客服"  prop="customerServiceStaff">
                <el-select v-model.lazy="form.customerServiceStaff">
                  <el-option v-for="(d, i) in customerServiceStaffs" :key="i" :label="d.name" :value="d.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="信用额度(元)"  prop="credits">
                <el-input v-model.lazy="form.credits" type="number" placeholder="信用额度"></el-input>
              </el-form-item>
              <el-form-item label="分配仓库"  prop="warehouse">
                <el-select v-model.lazy="form.warehouse" multiple filterable clearable>
                  <el-option v-for="(d, i) in warehouseData" :key="i" :label="d.name" :value="d.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分公司"  prop="companyId" >
                <el-select v-model.lazy="form.companyId" filterable clearable>
                  <el-option v-for="(d, i) in companys" :key="i" :label="d.name" :value="d.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </el-card>
    <div class="submit-buttons">
      <el-button @click="back">返 回</el-button>
      <el-button v-if="!isLook" type="primary" @click="subtmitForm('formref')">确 定</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var checkUsername = (rule, value, callback) => {
      let _this = this;
      if (value && value != "") {
        if (
          (_this.isEdit && _this.original.username != value) ||
          !_this.isEdit
        ) {
          callback();
        } else {
          callback();
        }
      } else {
        callback(new Error("登录账号必填"));
      }
    };
    var checkCompanyName = (rule, value, callback) => {
      let _this = this;
      if (value && value != "") {
        if (
          (_this.isEdit && _this.original.orgName != value) ||
          !_this.isEdit
        ) {
          //jioayan
          callback();
        } else {
          callback();
        }
      } else {
        callback(new Error("公司名称必填"));
      }
    };
    var checkEmail = (rule, value, callback) => {
      let _this = this;
      if (value && value != "") {
        if (
          /^[a-zA-Z0-9_-]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[_-a-zA-Z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$/.test(
            value
          )
        ) {
          // if (/^\w+@\w+(\.\w+){1,63}$/.test(value)) {
          callback();
        } else {
          callback(new Error("邮箱格式不正确"));
        }
      } else {
        callback(new Error("邮箱必填"));
      }
    };
    var checkCredits = (rule, value, callback) => {
      let _this = this;
      if (value && value != "" && !isNaN(value) && parseFloat(value) >= 0) {
        callback();
      } else {
        callback(new Error("请输入信用额度，数值必须大于等于0"));
      }
    };
    var checkPwd = (rule, value, callback) => {
      let _this = this;
      if (
        (value && value != "" && value.length >= 6 && value.length <= 16) ||
        _this.isEdit
      ) {
        callback();
      } else {
        callback(new Error("请输入密码，长度在 6 到 16 个字符"));
      }
    };

    return {
      form: {
        orgOwner: "",
        companyAddress: "",
        companyEmail: "",
        companyTel: "",
        createAt: "",
        companyCode: "",
        credits: "",
        customerServiceStaff: "",
        customerType: "",
        name: "",
        orderReview: "",
        deliveryConfirmation: "false",
        addressConfirm: "false", //api下单地址校验
        orgName: "",
        paymentTerms: "",
        pwd: "",
        salesman: "",
        userStatus: "",
        username: "",
        province: "",
        city: "",
        address: "",
        channel: "",
        channelName: "",
        channelQuote: "",
        warehouse: "",
        warehouseName: "",
        cashBeforeDeliveryChannel: "",
        cashBeforeDeliveryChannelName: "",
        companyId: "",
        viewBatchTracking:"true"
      },
      original: {
        companyEmail: "",
        username: "",
        orgName: ""
      },
      isEdit: false,
      formLabelWidth: "120px",
      dialogImageUrl: "", //上传图片
      dialogVisible: false,
      businessLicenseImg: "",
      businessLicenseImgUrl: "",
      imgListBusinessLicenseImg: [],
      openingAccountsImg: "",
      openingAccountsImgUrl: "",
      imgListOpeningAccountsImg: [],
      taxpayerImg: "",
      taxpayerImgUrl: "",
      imgListTaxpayerImg: [],
      contactIDFrontImg: "",
      contactIDFrontImgUrl: "",
      imgListContactIDFrontImg: [],
      contactIDBackImg: "",
      contactIDBackImgUrl: "",
      imgListContactIDBackImg: [],
      rulesform: {
        username: [
          {
            validator: checkUsername,
            trigger: "blur"
          }
        ],
        pwd: [{ validator: checkPwd, trigger: "blur" }],
        orgName: [
          {
            validator: checkCompanyName,
            trigger: "blur"
          }
        ],
        name: [{ required: true, message: "联系人不能为空", trigger: "blur" }],
        companyTel: [
          { required: true, message: "联系方式不能为空", trigger: "blur" }
        ],
        companyEmail: [
          { required: true, validator: checkEmail, trigger: "blur" }
        ],
        companyAddress: [
          { required: true, message: "联系地址不能为空", trigger: "blur" },
          {
            min: 6,
            max: 200,
            message: "长度在 6 到 200 个字符",
            trigger: "blur"
          }
        ],
        userStatus: {
          required: true,
          message: "请选择账号状态",
          trigger: "change"
        },
        salesman: {
          required: true,
          message: "请选择业务员",
          trigger: "change"
        },
        paymentTerms: {
          required: true,
          message: "请选择结算方式",
          trigger: "change"
        },
        customerType: {
          required: true,
          message: "请选择客户类型",
          trigger: "change"
        },
        channel: {
          required: true,
          message: "请选择产品",
          trigger: "change"
        },
        warehouse: {
          required: true,
          message: "请选择仓库",
          trigger: "change"
        },
        companyId: {
          required: true,
          message: "请选择分公司",
          trigger: "change"
        },
        orderReview: {
          required: true,
          message: "请选择是否审核订单",
          trigger: "change"
        },
        deliveryConfirmation: {
          required: true,
          message: "请选择是否确认发货",
          trigger: "change"
        },
        addressConfirm: {
          required: true,
          message: "请选择是否校验地址",
          trigger: "change"
        },
        customerServiceStaff: {
          required: true,
          message: "请选择客服",
          trigger: "change"
        },
        credits: {
          validator: checkCredits,
          trigger: "blur"
        }
      },
      customers: {},
      createAtOptions: {
        disabledDate(time) {
          return time < new Date(new Date().toLocaleDateString()).getTime();
        }
      },
      customerServiceStaffs: [],
      salesmans: [],
      paymentTermsList: [
        { name: "日结", value: "DAILY_SETTLEMENT" },
        { name: "周结", value: "WEEK_SETTLEMENT" },
        { name: "半月结", value: "HALF_MONTH_SETTLEMENT" },
        { name: "月结", value: "MONTHLY_STATEMENT" }
      ],
      customerTypeList: [
        // { name: "普通客户", value: "NORMAL" },
        // { name: "线上自营", value: "ONLINE_SELF_EMPLOYED" },
        // { name: "线下自营", value: "OFFLINE_SELF_EMPLOYED" },
        // { name: "线上代理", value: "ONLINE_AGENCY" },
        // { name: "线下代理", value: "OFFLINE_AGENCY" }
      ],
      userStatusList: [
        { name: "账号未启用", value: "INITIALIZE" },
        { name: "审核未通过", value: "NOTPASSED" },
        { name: "审核已通过", value: "PASSED" }
      ],
      userStatusListMap: {
        INITIALIZE: "账号未启用",
        NOTPASSED: "审核未通过",
        PASSED: "审核已通过"
      },
      initialDataProvinceChina: [],
      initialDataCityChina: [],
      channelData: [],
      warehouseData: [],
      cashBeforeDeliveryChannelData: [],
      companys: [],
      companyMap: {}
    };
  },
  components: {},
  created() {
    console.log(this.$route.query.look);
    if (this.$route.query.data && this.$route.query.data != "") {
      this.loadCustomerList();
      this.isEdit = true;
    }
    setTimeout(() => {
      this.loadRoleList("业务员");
      this.loadRoleList("客服");
      this.queryProvinceOfChina();
      this.initChannel();
      this.queryWarehouseData();
      this.getCustomerType();
      this.queryCompany();
    }, 1000);
  },
  computed: {
    isLook() {
      let isLook =
        this.$route.query.data &&
        (this.$route.query.look == "true" || this.$route.query.look === true)
          ? true
          : false;
      return isLook;
    },
    title() {
      let title = "";
      title = this.$route.query.data ? "编辑客户" : "新建客户";
      this.isLook && (title = "查看客户");
      return title;
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    checkEmailAjax() {
      let _this = this;
      return this.$request1.get(
        '/customer/email/check',
        {
          params: {
            email: _this.form.companyEmail
          }
        }
      );
    },
    // 获取客户类型
    getCustomerType() {
      this.$request1.get(
        '/customer/queryCustomerType'
      ).then(res => {
        if(res.data && res.data.length > 0) {
          this.customerTypeList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    checkCompanyNameAjax() {
      let _this = this;
      return this.$request1.get(
        '/customer/orgowner/check',
        {
          params: {
            name: _this.form.orgName
          }
        }
      );
    },
    checkUsernameAjax() {
      let _this = this;
      return this.$request1.get(
        '/customer/user/check',
        {
          params: {
            userName: _this.form.username
          }
        }
      );
    },
    subtmitForm(formref) {
      let _this = this;
      let _valid = true;
      this.$refs[formref].validate(valid => {
        if (!valid) {
          _valid = false;
        }
      });
      if (!_valid) {
        return false;
      }
      if (
        (_this.isEdit &&
          (_this.original.username != _this.form.username ||
            _this.original.orgName != _this.form.orgName ||
            _this.original.companyEmail != _this.form.companyEmail)) ||
        !_this.isEdit
      ) {
        _this.$axios.all([
            _this.checkUsernameAjax(),
            _this.checkCompanyNameAjax(),
            _this.checkEmailAjax()
          ])
          .then(
            _this.$axios.spread(function(username, companyName, email) {
              let _username = true;
              if (
                !username.data.success &&
                _this.original.username != _this.form.username
              ) {
                _username = false;
                _this.$message.error(username.data.message);
              }
              let _companyName = true;
              if (
                !companyName.data.success &&
                _this.original.orgName != _this.form.orgName
              ) {
                _companyName = false;
                _this.$message.error(companyName.data.message);
              }
              let _email = true;
              if (
                !email.data.success &&
                _this.original.companyEmail != _this.form.companyEmail
              ) {
                _email = false;
                _this.$message.error(email.data.message);
              }

              if (_username && _companyName && _email) {
                _this.createAndUpdate();
              }
            })
          );
      } else {
        _this.createAndUpdate();
      }
    },
    createAndUpdate() {
      let _this = this;
      var formData = new FormData();
      for (var key in _this.form) {
        formData.append(key, _this.form[key]);
      }
      if(_this.businessLicenseImg){
        formData.append("businessLicenseImg", _this.businessLicenseImg);
      }
      if(_this.openingAccountsImg){
        formData.append("openingAccountsImg", _this.openingAccountsImg);
      }
      if(_this.taxpayerImg){
        formData.append("taxpayerImg", _this.taxpayerImg);
      }
      if(_this.contactIDFrontImg){
        formData.append("contactIDFrontImg", _this.contactIDFrontImg);
      }
      if(_this.contactIDBackImg){
        formData.append("contactIDBackImg", _this.contactIDBackImg);
      }

      _this.$request1
        .post(
          '/customer',
          formData,
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          console.log(res);
          if (res.status == 413) {
            _this.$notify.error({
              title: "错误",
              message:
                "提交数据量过大,保存失败,请调整图片大小或内容长度后再尝试保存。"
            });
          } else {
            if (res.data.success) {
              _this.$message.success("成功");
              setTimeout(function() {
                _this.$router.push("/customer/customerlist");
              }, 2000);
            } else {
              _this.$notify.error({
                title: "错误",
                message: res.data.message,
                duration: 0
              });
            }
          }
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 413) {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message: error.response.statusText,
              duration: 0
            });
          }
        });
    },
    loadCustomerList() {
      let _this = this;
      _this.$request1
        .post(
          '/querycustomer',
          {
            orgOwner: _this.$route.query.data,
            customerType: "",
            salesman: "",
            customerServiceStaff: "",
            userStatus: "",
            currentPage: 1,
            pageSize: 100
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          // console.log(res);
          if (res.data.success) {
            let _customers = res.data.data[0];
            _this.form.orgOwner = _customers.orgOwner;
            _this.form.companyAddress = _customers.companyAddress;
            _this.form.companyCode = _customers.companyCode;
            _this.form.companyEmail = _customers.companyEmail;
            _this.form.companyTel = _customers.companyTel;
            if (_customers.province) {
              _this.form.province = _customers.province;
            }
            if (_customers.city) {
              _this.form.city = _customers.city;
            }
            if (_customers.address) {
              _this.form.address = _customers.address;
            }
            let _createAt = new Date(_customers.createAt);

            _this.form.createAt =
              _createAt.getFullYear() +
              "-" +
              (_createAt.getMonth() + 1) +
              "-" +
              _createAt.getDate();
            _this.form.credits = _customers.customerAttach.credits;
            _this.form.customerServiceStaff =
              _customers.customerAttach.customerServiceStaff;
            _this.form.customerServiceStaffName =
              _customers.customerAttach.customerServiceStaffName;
            _this.form.customerType = _customers.customerAttach.customerType;
            _this.form.customerTypeName =
              _customers.customerAttach.customerTypeName;
            _this.form.name = _customers.user;
            _this.form.orderReview = _customers.customerAttach.orderReview
              ? "true"
              : "false";
            _this.form.deliveryConfirmation = _customers.customerAttach
              .deliveryConfirmation
              ? "true"
              : "false";
            _this.form.addressConfirm = _customers.customerAttach.addressConfirm
              ? "true"
              : "false";
            _this.form.orgName = _customers.name;
            _this.form.paymentTerms = _customers.customerAttach.paymentTerms;
            _this.form.paymentTermsName =
              _customers.customerAttach.paymentTermsName;
            _this.form.pwd = "";
            _this.form.salesman = _customers.customerAttach.salesman;
            _this.form.salesmanName = _customers.customerAttach.salesmanName;
            _this.form.userStatus = _customers.userStatus;
            _this.form.username = _customers.username;

            if (_customers.businessLicenseImg) {
              _this.businessLicenseImgUrl = _customers.businessLicenseImg;
              let bfile = new Object();
              bfile.url = _customers.businessLicenseImg;
              _this.imgListBusinessLicenseImg.push(bfile);
            }
            if (_customers.openingAccountsImg) {
              _this.openingAccountsImgUrl = _customers.openingAccountsImg;
              let ofile = new Object();
              ofile.url = _customers.openingAccountsImg;
              _this.imgListOpeningAccountsImg.push(ofile);
            }
            if (_customers.taxpayerImg) {
              _this.taxpayerImgUrl = _customers.taxpayerImg;
              let tfile = new Object();
              tfile.url = _customers.taxpayerImg;
              _this.imgListTaxpayerImg.push(tfile);
            }
            if (_customers.contactIDFrontImg) {
              _this.contactIDFrontImgUrl = _customers.contactIDFrontImg;
              let idffile = new Object();
              idffile.url = _customers.contactIDFrontImg;
              _this.imgListContactIDFrontImg.push(idffile);
            }
            if (_customers.contactIDBackImg) {
              _this.contactIDBackImgUrl = _customers.contactIDBackImg;
              let idbfile = new Object();
              idbfile.url = _customers.contactIDBackImg;
              _this.imgListContactIDBackImg.push(idbfile);
            }

            _this.original.companyEmail = _customers.companyEmail;
            _this.original.username = _customers.username;
            _this.original.orgName = _customers.name;
            _this.original.companyCode = _customers.companyCode;

            if (
              _customers.customerAttach.channel &&
              _customers.customerAttach.channel.length > 0
            ) {
              _this.form.channel = _customers.customerAttach.channel.split(",");
            }
            if (
              _customers.customerAttach.channelQuote &&
              _customers.customerAttach.channelQuote.length > 0
            ) {
              _this.form.channelQuote = _customers.customerAttach.channelQuote.split(",");
            }

            if(
              _customers.customerAttach.cashBeforeDeliveryChannel &&
              _customers.customerAttach.cashBeforeDeliveryChannel.length > 0
            ) {
              _this.form.cashBeforeDeliveryChannel = _customers.customerAttach.cashBeforeDeliveryChannel.split(",");
            }
            if (
              _customers.customerAttach.warehouse &&
              _customers.customerAttach.warehouse.length > 0
            ) {
              _this.form.warehouse = _customers.customerAttach.warehouse.split(
                ","
              );
            }

            // 分公司
            _this.form.companyId = _customers.companyId;


          } else {
            _this.customers = {};
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadRoleList(role) {
      let _this = this;
      _this.$request1
        .get(
          '/staffrole',
          {
            params: {
              role: role
            }
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            if (role == "业务员") {
              _this.salesmans = res.data.data;
            } else if (role == "客服") {
              _this.customerServiceStaffs = res.data.data;
            }
          } else {
            _this.salesmans = [];
            _this.customerServiceStaffs = [];
            // _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    imgChangeBusinessLicenseImg(file, fileList) {
      if (file.raw.size > 1024 * 1024 * 10) {
        this.$message.error("单张照片限制最大10M");
        this.imgListBusinessLicenseImg = [];
      } else {
        this.businessLicenseImg = file.raw;
      }
    },
    imgChangeOpeningAccountsImg(file, fileList) {
      if (file.raw.size > 1024 * 1024 * 10) {
        this.$message.error("单张照片限制最大10M");
        this.imgListOpeningAccountsImg = [];
      } else {
        this.openingAccountsImg = file.raw;
      }
    },
    imgChangeTaxpayerImg(file, fileList) {
      if (file.raw.size > 1024 * 1024 * 10) {
        this.$message.error("单张照片限制最大10M");
        this.imgListTaxpayerImg = [];
      } else {
        this.taxpayerImg = file.raw;
      }
    },
    imgChangeContactIDFrontImg(file, fileList) {
      if (file.raw.size > 1024 * 1024 * 10) {
        this.$message.error("单张照片限制最大10M");
        this.imgListContactIDFrontImg = [];
      } else {
        this.contactIDFrontImg = file.raw;
      }
    },
    imgChangeContactIDBackImg(file, fileList) {
      if (file.raw.size > 1024 * 1024 * 10) {
        this.$message.error("单张照片限制最大10M");
        this.imgListContactIDBackImg = [];
      } else {
        this.contactIDBackImg = file.raw;
      }
    },
    rmBusinessLicenseImg(file, fileList) {
      this.businessLicenseImg = null;
    },
    rmOpeningAccountsImg(file, fileList) {
      this.openingAccountsImg = null;
    },
    rmTaxpayerImg(file, fileList) {
      this.taxpayerImg = null;
    },
    rmContactIDFrontImg(file, fileList) {
      this.contactIDFrontImg = null;
    },
    rmContactIDBackImg(file, fileList) {
      this.contactIDBackImg = null;
    },
    queryProvinceOfChina() {
      var _this = this;
      _this.$request1
        .get(
          '/province/' + 1 + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataProvinceChina = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryCityOfChina(province) {
      var _this = this;
      _this.form.city = "";
      let _provinceId = null;
      _this.initialDataProvinceChina.forEach((d, i) => {
        if (d.nameCn == province) {
          _provinceId = d.id;
        }
      });
      if (!_provinceId) {
        return false;
      }

      _this.$request1
        .get(
          '/city/' + _provinceId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          console.log(response);
          if (response.status == 200 && response.data.success) {
            _this.initialDataCityChina = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initChannel(nameCN, type, open) {
      this.$request1({
        method: 'GET',
        url: '/system/channel/query',
        params: {
          nameCN: nameCN,
          type: type,
          status: 1,
          open: open,
          currentPage: 1,
          pageSize: 10000
        }
      })
        .then(response => {
          if (response.data.success) {
            if (response.data.data && response.data.data.length > 0) {
              this.channelData = response.data.data;
              this.channelData.forEach((d, i) => {
                if (this.form.channel.includes(d.id)) {
                  this.form.channelName += d.nameCN + "\t";
                }
              });
              if (this.$route.query.data && this.$route.query.data != "") {
                this.getCashBeforeDeliveryChannel();
              }
              this.channelData.forEach((d, i) => {
                if (this.form.cashBeforeDeliveryChannel.includes(d.id)) {
                  this.form.cashBeforeDeliveryChannelName += d.nameCN + "\t";
                }
              });
            } else {
              this.channelData = [];
            }
          } else {
            // this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    queryWarehouseData() {
      this.$request1({
        method: 'GET',
        url: '/warehouse/load',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          if (response.data.data) {
            this.warehouseData = response.data.data;
            this.warehouseData.forEach((d, i) => {
              if (this.form.warehouse.includes(d.id)) {
                this.form.warehouseName += d.name + "\t";
              }
            });
          } else {
            this.warehouseData = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    queryCompany(){
        let _this = this;
        this.$request1({
            method: 'get',
            url: '/system/company',
            params: {
              page:  1,
              pageSize: -1
            }
        })
        .then(response => {          
            _this.companys = response.data.data;
            _this.companys.forEach(a => {
                _this.companyMap[a.id] = a.name;
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCashBeforeDeliveryChannel() {
      let _this = this;
      _this.cashBeforeDeliveryChannelData = [];

      if (_this.form.channel.length == 0) {
        _this.form.cashBeforeDeliveryChannel = [];
      }
      _this.channelData.forEach((item, index) => {
        _this.form.channel.forEach((data, index) => {
          if (item.id == data) {
            let channel = { id: "", nameCN: "" };
            channel.id = item.id;
            channel.nameCN = item.nameCN;
            _this.cashBeforeDeliveryChannelData.push(channel);
          }
        });
      });

      let cashBeforeDeliveryChannel = [];
      _this.cashBeforeDeliveryChannelData.forEach((item, index) => {
        _this.form.cashBeforeDeliveryChannel.forEach((data, index) => {
          if (item.id == data) {
            cashBeforeDeliveryChannel.push(data);
          }
        });
      });
      _this.form.cashBeforeDeliveryChannel = cashBeforeDeliveryChannel;
    }
  }
};
</script>

<style lang="scss" scoped>
.img {
  width: 300px;
  height: auto;
}
.inline-flex{
  display: flex; 
  flex-wrap: wrap;
  >:first-child{
    margin-right: 15px;
  }
}
.img-box{
  display: flex;
  .box{
    &:first-child{
      margin-right: 100px;
    }
    .label{
      margin-bottom: 10px;
      font-size: 14px;
      color: #99a9bf;
    }
    .img {
      width: 300px;
      height: auto;
    }
  }
  &:not(:last-child) {
    margin-bottom: 30px;
  }
}
.padding-left{
  padding-left: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/customer/newcustomer.vue